import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import styles from '../../../styles/UAEPageComponents.module.css'

const OutletTypes = ({title, data = []}) => {


  const imageRefs = useRef([])
  const cardRefs = useRef([])
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    if (!isMounted) return
    
    let gsapModule
    const setup = async () => {
      if (typeof window === 'undefined') return
      
      // Wait for next frame to ensure hydration is complete
      await new Promise(resolve => requestAnimationFrame(resolve))
      // Additional small delay to ensure hydration is fully complete
      await new Promise(resolve => setTimeout(resolve, 0))
      
      const { gsap } = await import('gsap')
      gsapModule = gsap

      cardRefs.current.forEach((cardEl, idx) => {
        const el = imageRefs.current[idx]
        if (!cardEl || !el) return
        const hoverColor = cardEl.dataset.hoverColor || '#225590'

        // Set initial styles after hydration to ensure consistent state
        // These are set after hydration completes to avoid hydration mismatch
        gsap.set(el, { 
          rotate: 0, 
          scale: 1, 
          y: 0, 
          zIndex: 1, 
          transformOrigin: '50% 50%'
        })
        gsap.set(cardEl, { 
          backgroundColor: '#FFFFFF'
        })

        const onEnter = () => {
          const titleEl = cardEl.querySelector('h4')
          gsap.killTweensOf([el, cardEl, titleEl])
          const tl = gsap.timeline({ overwrite: 'auto' })
          tl.to(el, {
            rotate: idx % 2 === 0 ? 3 : -3,
            scale: 1.20,
            y: -12,
            duration: 1,
            ease: 'back.out(5)',
            zIndex: 2,
            force3D: true,
          })
          

          gsap.to(cardEl, { backgroundColor: hoverColor, duration: 0.4, overwrite: 'auto' })
          if (titleEl) {
            gsap.to(titleEl, { 
              color: '#FFFFFF', 
              scale: 1.20,
              duration: 1, 
              overwrite: 'auto' ,
              ease: 'back.out(5)',
            })
          }
        }

        const onLeave = () => {
          const titleEl = cardEl.querySelector('h4')
          gsap.killTweensOf([el, cardEl, titleEl])
          gsap.to(el, { 
            rotate: 0, 
            scale: 1,
            y: 0,
            duration: 1, 
            ease: 'back.out(5)',
            zIndex: 1,
            overwrite: 'auto',
            force3D: true,
          })
          gsap.to(cardEl, { backgroundColor: '#FFFFFF', duration: 0.4, overwrite: 'auto' })
          if (titleEl) {
            gsap.to(titleEl, { 
              color: '#161747', 
              scale: 1,
              duration: 0.4, 
              overwrite: 'auto' 
            })
          }
        }

        cardEl.addEventListener('mouseenter', onEnter)
        cardEl.addEventListener('mouseleave', onLeave)
        cardEl.__onEnter = onEnter
        cardEl.__onLeave = onLeave
      })
    }

    setup()

    return () => {
      if (cardRefs.current) {
        cardRefs.current.forEach((cardEl) => {
          if (!cardEl) return
          if (cardEl.__onEnter) cardEl.removeEventListener('mouseenter', cardEl.__onEnter)
          if (cardEl.__onLeave) cardEl.removeEventListener('mouseleave', cardEl.__onLeave)
          delete cardEl.__onEnter
          delete cardEl.__onLeave
        })
      }
      gsapModule = undefined
    }
  }, [data, isMounted])

  const rows = React.useMemo(() => {
    if (!Array.isArray(data)) return []
    const chunked = []
    for (let i = 0; i < data.length; i += 4) {
      chunked.push(data.slice(i, i + 4))
    }
    return chunked
  }, [data])

  return (
    <>  
    <div className={styles.retailOutletMainWrapper}>
        <div className={styles.retailOutletWrapper}> 
        <div className={styles.gradientSection} >
        <div className={styles.gradientBlue}></div>
        <div className={styles.gradientOrange} style={{marginRight:"-25rem"}} ></div>
      </div>
         <div>
            <div className={styles.titleContainer}>
               <p style={{margin:0, padding:0,fontSize: '1.6rem', fontFamily: 'GilroySemiBold'}}>{title}</p>
            </div>
          </div> <br />
      <div className={styles.retailOutletGrid}>
        {rows.map((row, rowIdx) => {
          return (
            <div
              key={`retail-row-${rowIdx}`}
              className={styles.retailOutletRow}
              style={{ justifyContent: row.length < 4 ? 'center' : undefined }}
            >
              {row.map((item, idx) => {
                const globalIdx = rowIdx * 4 + idx
                return (
                  <div
                    key={`${item?.title || idx}-${globalIdx}`}
                    className={styles.retailOutletCard}
                    ref={(el) => (cardRefs.current[globalIdx] = el)}
                    data-hover-color={item?.hoverColor}
                  >
                    <div
                      className={styles.retailOutletImage}
                      ref={(el) => (imageRefs.current[globalIdx] = el)}
                    >
                      {item?.image && <Image src={item.image} alt={item?.title || ''} fill style={{ objectFit: "contain", objectPosition: "center" }} />}
                    </div>
                    {item?.title && <h4 className={styles.retailOutletTitle}>{item.title}</h4>}
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
    </div>
    </>
  )
}

export default OutletTypes